import { VERIFY_CONTEST_ERROR, VERIFY_CONTEST_REQUEST, VERIFY_CONTEST_FINISH, VERIFY_CONTEST_SUCCESS } from "../Const/const"
import ContestApi from "../ReduxApi/contestApi";

export const verifyContestAction = (token) => async (dispatch) => {
    dispatch({
        type: VERIFY_CONTEST_REQUEST
    })
    
    const contest = await ContestApi.verifyCurrentContest(token)
    console.clear()
    if (contest?.status === 200 || contest?.status === 201) {
        const data = contest.objectVal ? contest.objectVal : { isValidContest: false, contestId: null }
        dispatch({
            type: VERIFY_CONTEST_SUCCESS,
            payload: data
        })
    }else{
        dispatch({
            type: VERIFY_CONTEST_ERROR
        })
    }
}

export const finishVerificationContest = () => async (dispatch) => {
    dispatch({
        type: VERIFY_CONTEST_FINISH,
    })
}

